/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as React from 'react';

export default class Alert extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            type: props.type ? props.type : 'info',
            children: props.children,
            message: props.message,
            icon: props.icon ? props.icon : 'InfoCircle'
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            this.setState({ children: this.props.children });
        }
    }

    render() {
        var n = 0;
        return (<div className={'alert alert-' + this.state.type + (this.props.className ? ' ' + this.props.className : '')}>
            {!this.props.noIcon ? <FontAwesomeIcon icon={fa['fa' + this.state.icon]} className="me-2" /> : ''}
            {this.props.children ? (this.props.children.map ? this.props.children.map((obj) => (<span key={n++}>{obj}</span>)) : this.props.children) : this.props.message}
        </div >);
    }
}

